import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { Address } from '../../core/generated';
import { StateFormatPipe } from '../pipes/state-format.pipe';


@Component({
    selector: 'app-address-list',
    standalone: true,
    imports: [CommonModule, MaterialModule, StateFormatPipe],
    templateUrl: './address-list.component.html',
    styleUrls: ['./address-list.component.scss']
})
export class AddressListComponent {

  @Input() addresses: Address[] = [];
  @Output() addAddress = new EventEmitter<void>();
  @Output() deleteAddress = new EventEmitter<number>();
  @Output() editAddress = new EventEmitter<number>();
  @Output() setCommercialAddress = new EventEmitter<number>();

  onAddAddress() {
    this.addAddress.emit();
  }
}